import { render } from "./ToggleSwitch.vue?vue&type=template&id=75149544&scoped=true&ts=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=75149544&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75149544"]])

export default __exports__